module.exports = vue_library;